import {type MapMarkerProps, MapMarker} from '@yandex-delivery/blocks'
import {type PropsWithChildren, type ReactElement} from 'react'

import {PointMarkerIcon} from './PointMarkerIcon'
import type {PointMarkerType} from './types'

type Props = MapMarkerProps &
  PropsWithChildren<{
    type?: PointMarkerType
  }>

export function PointMarker(props: Props): ReactElement {
  const {type, children, draggable, ...markerProps} = props

  return <MapMarker {...markerProps}>{PointMarkerIcon({draggable, type, children})}</MapMarker>
}
